import { noticeError } from '../apis/newRelicTracking';

export const REDUX_CRASH_REPORTER_ORIGIN = 'reduxCrashReporter';

export const crashReporter = _ => next => action => {
  try {
    return next(action);
  } catch (error) {
    console.error(
      '[ReduxCrashReporter] Error Caught During Redux Execution',
      error
    );

    noticeError(error);
    error.nrReporterSource = REDUX_CRASH_REPORTER_ORIGIN;
    throw error;
  }
};
